import { useState } from '@hookstate/core';

import FilterImage from '@assets/svg/filter.svg';
import { CSSTransition } from 'react-transition-group';
import { countFilter } from '@utils/countFilter/getFilterRequest';
import { ClickAwayListener } from '@material-ui/core';
import { FilterProductContent } from './components';

import {
  Container,
  ButtonAddField,
  Block,
  CircleDiv,
} from './FilterProduct.styles';
import { IProductFilterData } from './types';

interface FilterProps {
  filterData: IProductFilterData;
  startSearch: () => void;
  setFilterData: (newFilter: FilterProps['filterData']) => void;
}

const FilterProduct = ({
  filterData,
  startSearch,
  setFilterData,
}: FilterProps) => {
  const open = useState(false);
  const filterCount = countFilter(filterData);
  const handleClickAway = () => {
    open.set(false);
  };
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Container>
        <ButtonAddField onClick={() => open.set(true)}>
          <img src={FilterImage} alt="filter" />
        </ButtonAddField>
        {filterCount > 0 && <CircleDiv>{filterCount}</CircleDiv>}
        <CSSTransition
          in={open.get()}
          timeout={300}
          classNames="my-node"
          unmountOnExit
          onEnter={() => open.set(true)}
          onExited={() => open.set(false)}
        >
          <Block>
            <FilterProductContent
              openAddField={open}
              setFilterData={setFilterData}
              filterData={filterData}
              startSearch={startSearch}
              filterCount={filterCount}
            />
          </Block>
        </CSSTransition>
      </Container>
    </ClickAwayListener>
  );
};

export { FilterProduct };
